/**
 * Shared Socket.IO event type definitions.
 * These are used by both the server (emits) and client (subscribes).
 */
// ===== Task Events =====
export const TaskEvents = {
    /** A task was created */
    Created: 'task:created',
    /** A task was updated (field changes) */
    Updated: 'task:updated',
    /** A task's status changed (Kanban move) */
    StatusChanged: 'task:statusChanged',
    /** A task was reordered (sort order change) */
    Moved: 'task:moved',
    /** A task was deleted */
    Deleted: 'task:deleted',
};
// ===== Notification Events =====
export const NotificationEvents = {
    /** A new notification was created for a user */
    New: 'notification:new',
    /** Notifications were marked as read */
    Read: 'notification:read',
};
// ===== Quote Events =====
export const QuoteEvents = {
    /** A quote was created */
    Created: 'quote:created',
    /** A quote's status changed (draft → sent → approved → accepted → expired etc.) */
    StatusChanged: 'quote:statusChanged',
};
// ===== Room Names =====
/**
 * Users join rooms named after their userId to receive personal notifications.
 * They also join project rooms for project-scoped events.
 */
export const SocketRooms = {
    user: (userId) => `user:${userId}`,
    project: (projectId) => `project:${projectId}`,
};
//# sourceMappingURL=socket-events.js.map